/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_Exists_NoteInputs */

const en_directory_submit_check_exists_note = /** @type {(inputs: Directory_Submit_Check_Exists_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If this is your product or you are submitting something different on the same domain, you can still continue — the review team will take a look.`)
};

const zh_directory_submit_check_exists_note = /** @type {(inputs: Directory_Submit_Check_Exists_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果这是你的产品、或你想在同一域名下提交不同的内容，仍可继续 — 审核团队会进行核实。`)
};

/**
* | output |
* | --- |
* | "If this is your product or you are submitting something different on the same domain, you can still continue — the review team will take a look." |
*
* @param {Directory_Submit_Check_Exists_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_exists_note = /** @type {((inputs?: Directory_Submit_Check_Exists_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_Exists_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_exists_note(inputs)
	return zh_directory_submit_check_exists_note(inputs)
});
export { directory_submit_check_exists_note as "directory.submit.check.exists_note" }